export default "__VITE_ASSET__b16d60b0__"